<template>
  <div>
    <table :class="$style['customer-message-old-to-new']">
      <template v-if="!isManualReward">
        <pt-message-table-item label="奖励发放流水号"  @widthItem="widthItem">{{BringNewAuditDetail.number}}</pt-message-table-item>
        <pt-message-table-item label="事业部归属">{{BringNewAuditDetail.businessDepartmentName||'--'}}</pt-message-table-item>
        <pt-message-table-item label="申请ID">{{customerBringNew.serialNumber}}</pt-message-table-item>
        <pt-message-table-item label="申请日期">{{BringNewAuditDetail.achieve_date}}</pt-message-table-item>
        <pt-message-table-item label="所属分公司">{{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.cpsOrgName}}</pt-message-table-item>
        <pt-message-table-item label="奖励用户类型">{{BringNewAuditDetail.userType}}</pt-message-table-item>
        <pt-message-table-item label="奖励轮次">
          {{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.customerBringNew&&BringNewAuditDetail.extendInformation.customerBringNew.finalRewardCount}}
          <!-- {{extendInformation.rewardCount?(extendInformation.rewardCount>=2?"第二轮":"第一轮"):"--"}} -->
          </pt-message-table-item>
      </template>
      <!-- <pt-message-table-item label="状态">{{BringNewAuditDetail.audit_status}}</pt-message-table-item>
        <pt-message-table-item label="催费次数" v-if="!isManualReward">
          <template v-if="BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.userType==='NEW'">--</template>
          <template v-else>
          {{BringNewAuditDetail.extendInformation&&(BringNewAuditDetail.extendInformation.remindPayNumber?BringNewAuditDetail.extendInformation.remindPayNumber:'--')}}
          </template>
          </pt-message-table-item> -->
      <pt-message-table-item label="发放时间">{{isManualReward?BringNewAuditDetail.created_date:BringNewAuditDetail.reward_date}}</pt-message-table-item>
      <pt-message-table-item label="发放人">{{BringNewAuditDetail.rewardUserName}}</pt-message-table-item>
      <pt-message-table-item label="奖励类别">{{businessType}}</pt-message-table-item>
      <pt-message-table-item label="返现"><span :class="$style['money-reward-amount']">{{BringNewAuditDetail.reward_money}}</span>元</pt-message-table-item>
      <pt-message-table-item label="公司实付" v-if="isManualReward"><span :class="$style['money-reward-amount']">{{BringNewAuditDetail.reward_realPay}}</span>元</pt-message-table-item>
      <pt-message-table-item label="返劵"><span :class="$style['money-reward-amount']">{{BringNewAuditDetail.couponRewardAmount}}</span>元</pt-message-table-item>
    </table>
      <div :class="$style['selected-coupon-div']" v-if="coupon_list&&coupon_list.length>0">
        <div :class="$style['selected-coupon']">
            <template>
              <wt-table :list="coupon_list">
                  <template>
                      <el-table-column label="优惠劵:">
                          <template slot-scope="scope">
                              {{scope.row.couponData&&scope.row.couponData.name}}
                          </template>
                      </el-table-column>
                      <el-table-column label="优惠劵内容">
                          <template slot-scope="scope">
                              <div>{{scope.row.discount}}</div>
                              <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
                          </template>
                      </el-table-column>
                      <!-- <el-table-column label="剩余库存（张）">
                          <template slot-scope="scope">
                              {{scope.row.surplusAmount}}
                          </template>
                      </el-table-column> -->
                      <el-table-column label="赠券张数">
                          <template slot-scope="scope">
                              <!-- <wt-input v-model="scope.row.amount" v-if="isEditCoupons"></wt-input> -->
                              <template>{{scope.row.amount}}</template>
                          </template>
                      </el-table-column>
                  </template>
              </wt-table>
             </template>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  props: {
    BringNewAuditDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    coupon_list: {
      type: Array,
      default: function () {
        return []
      }
    },
    tdMaxWidth: {
      type: [String, Number],
      default: null
    },
    isManualReward: {
      type: Boolean,
      default: false
    }
  },
  computed: {

    //
    extendInformation () {
      return this.BringNewAuditDetail.extendInformation || {}
    },
    customerBringNew () {
      return this.extendInformation.customerBringNew || {}
    }
  },
  watch: {
    BringNewAuditDetail: {
      handler: function (val) {
        this.businessType = this.BringNewAuditDetail.rewardType ? this.BringNewAuditDetail.rewardType : this.BringNewAuditDetail.business_type
      }
    }
  },
  data () {
    return {
      businessType: null
    }
  },
  methods: {
    widthItem (val) {
      this.$emit('widthItem', val)
    }
  },
  created () {
    console.log('this.$router', this.$route)
  }
}
</script>
<style module lang="less">
@import "~less/var";
.customer-message-old-to-new{
  padding: 0 20px;
  :global
  .pt-message-table-item{
    :first-child{
      width: 114PX
    }
  }
}
.money-reward-amount{
  color: @mainColor;
  font-weight: 600;
  font-size: 17px;
  margin-right: 5px;
}
.selected-coupon-div{
  padding: 0 80px;

}
.selected-coupon{
  padding: 20px;
  background-color: #F9F9F9;
  min-width: 600px;
  :global
  .wt-table{
    *{
      background-color: #F9F9F9;
    }
    }
}
</style>
